/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ECourseStatus } from "../types/ECourseStatus.ts";

/**
 * @description 1 = Released | 2 = Canceled | 3 = Finalized |
 */
export const eCourseStatusSchema = z
  .union([z.literal(1), z.literal(2), z.literal(3)])
  .describe(
    "1 = Released | 2 = Canceled | 3 = Finalized | ",
  ) as unknown as ToZod<ECourseStatus>;
